import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMProject } from "../graphql/mutations";
import {
  UpdateLLMProjectMutation,
} from "../API";

export async function updateLLMProjectStatus(
  id: string,
  status: string
): Promise<GraphQLResult<UpdateLLMProjectMutation>> {
  return API.graphql(
    graphqlOperation(updateLLMProject, {
      input: {
        id: id,
        status: status,
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMProjectMutation>>;
}
